import { ISO6391LanguageCode } from 'shared/types/locale';

export function getHelpPageAboutUserRolesUrl(
  locale: ISO6391LanguageCode
): string {
  switch (locale) {
    case ISO6391LanguageCode.en:
      return 'https://help.hustro.com/en/article/user-roles';
    case ISO6391LanguageCode.pl:
      return 'https://help.hustro.com/pl/article/role';
    default:
      return 'https://help.hustro.com/en/article/user-roles';
  }
}
